import React from 'react';

const Footer = () => {
    return (
        <div className='bg-black py-5'>
            <p className='text-warning mt-5 mb-0 text-center'>CopyRight ©2022</p>
            <p className='text-white text-center'>Follow us </p>
        </div>
    );
};

export default Footer;